import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import { SSHUser } from "userful-chronos-app-common-js/dist/models/config/sshUsers";
import {
    RESPONSE_ADD_OR_UPDATE_SSH_USER,
    RESPONSE_LIST_SSH_USERS,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/config/sshUserMsgDefinitions";
import configStore from "./configStore";
import { sshUsersActions } from "./sshUsersSlice";

registerMsgHandler(RESPONSE_LIST_SSH_USERS, (payload) => {
    console.debug("RESPONSE_LIST_SSH_USERS");
    const data = JSON.parse(payload) as SSHUser[];
    configStore.dispatch(sshUsersActions.setData(data));
});

registerMsgHandler(RESPONSE_ADD_OR_UPDATE_SSH_USER, (payload) => {
    console.debug("RESPONSE_ADD_OR_UPDATE_SSH_USER");
    const data = JSON.parse(payload) as SSHUser;
    configStore.dispatch(sshUsersActions.addOrUpdateData(data));
});
